import React, { useEffect, useState } from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import { Navbar, Footer } from '../components/Navbar';
import { api } from '../lib/api';

export default function PlaqueOrderSuccess() {
  const [params] = useSearchParams();
  const sessionId = params.get('session_id');
  const [order, setOrder] = useState(null);
  const [status, setStatus] = useState('checking');

  useEffect(() => {
    if (!sessionId) return;
    let attempts = 0;
    const poll = async () => {
      attempts += 1;
      try {
        const { data } = await api.get(`/plaque-orders/status/${sessionId}`);
        setOrder(data);
        if (data?.payment_status === 'paid') {
          setStatus('paid');
        } else if (attempts >= 12) {
          setStatus('pending');
        } else {
          setTimeout(poll, 2500);
        }
      } catch {
        if (attempts < 12) setTimeout(poll, 2500);
        else setStatus('error');
      }
    };
    poll();
  }, [sessionId]);

  return (
    <div className="min-h-screen bg-background">
      <Navbar />
      <main className="ml-container py-16 max-w-2xl text-center">
        <h1 className="font-serif text-4xl text-[hsl(var(--primary))]" data-testid="plaque-success-title">
          {status === 'paid' ? 'Thank you — your order is in.' : 'Confirming your payment…'}
        </h1>
        <p className="text-sm text-[hsl(var(--primary)/0.7)] mt-4 max-w-lg mx-auto">
          {status === 'paid'
            ? 'A confirmation email is on its way. Your order will be prepared and reviewed by our team before production.'
            : 'This usually takes a few seconds. You can safely close this page — your order is safely on file.'}
        </p>
        {order?.order_id && (
          <div className="mt-6 inline-flex items-center gap-2 bg-[hsl(var(--accent))]/10 border border-[hsl(var(--accent))]/40 rounded-full px-5 py-2 text-xs">
            <span className="uppercase tracking-[0.18em] text-[hsl(var(--accent))]">Order ID</span>
            <span className="font-mono text-[hsl(var(--primary))]">{order.order_id}</span>
          </div>
        )}
        <div className="mt-10">
          <Link to="/dashboard" className="ml-btn-secondary" data-testid="plaque-success-back">Return to dashboard</Link>
        </div>
      </main>
      <Footer />
    </div>
  );
}
